import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchSalesRepCallGoals, salesRepActionCreators, salesRepActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { fetchSalesRepCallGoals } from '../salesRepApi';
import { ISalesRepCallGoal } from '../salesRepInterfaces';

function* fetchSalesRepCallGoalsSaga(action: FetchSalesRepCallGoals) {
  yield put(uiActionCreators.toggleLoading('salesRepCallGoals'));

  const response: IApiExecuteRespone<ISalesRepCallGoal> = yield call(
    fetchSalesRepCallGoals,
    action.payload.sid,
    action.payload.fiscalYear
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(salesRepActionCreators.setSalesRepCallGoals([response.value]));
  }

  yield put(uiActionCreators.toggleLoading('salesRepCallGoals'));
}

export function* watchFetchSalesRepCallGoals() {
  yield takeEvery(salesRepActionKeys.FETCH_SALES_REP_CALL_GOALS, fetchSalesRepCallGoalsSaga);
}
